export function isPlaceholderUsid(usid) {
  if (usid == null) {
    return true;
  }
  const value = String(usid).trim();
  return value === '' || value.toUpperCase() === 'OVERRIDE';
}

export function resolveStoredUsid(usid) {
  return isPlaceholderUsid(usid) ? '' : String(usid);
}
